module.exports = __webpack_public_path__ + "img/avatar.661d22ee.png";